import { Component } from '@angular/core';

@Component({
  selector: 'app-loading4',
  templateUrl: './loading4.component.html',
  styleUrls: ['./loading4.component.scss']
})
export class Loading4Component {

}
